import { cn } from '@/lib/utils'
import { PropsWithChildren } from 'react'
import { Helmet } from 'react-helmet'
import { useTheme } from '@/components/theme-provider'
import { useCustomDomain } from '../hooks/useCustomDomain'

type MainProps = PropsWithChildren<{
  title?: string
  fullWidth?: boolean
}>

const Main = ({ fullWidth, title, children }: MainProps) => {
  const { currentScheme } = useTheme()
  const { customDomain } = useCustomDomain()

  const backgroundImage =
    currentScheme === 'dark'
      ? customDomain?.darkModeBodyBackgroundPath
      : customDomain?.lightModeBodyBackgroundPath

  return (
    <main
      className='min-w-0 flex-1'
      style={{
        backgroundImage: backgroundImage
          ? `url(${backgroundImage})`
          : undefined,
      }}
    >
      <Helmet>
        <title>{[title, 'wowaudit'].filter(Boolean).join(' | ')}</title>
      </Helmet>
      <div className={cn('min-w-0 mt-8 pb-10', fullWidth ? '' : 'root-width')}>
        {children}
      </div>
    </main>
  )
}

export default Main
